import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChange, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { NormasService } from '../_services/normas.service';
import { UsuariosService } from '../_services/usuarios.service';
import { Modulo } from '../_models/modulo.model';

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";

declare var jQuery:any;


@Component({
  selector: 'formulariopermisospenal',
  templateUrl: 'formulariopermisospenal.template.html',
  //providers:  [PreguntasService]
})
export class FormularioPermisosPenalComponent  implements OnInit, OnDestroy, OnChanges {

  @Input() _titulo_permiso: string;
  @Input() _id_permiso: number;
  @Input() _tipo: string;

  @Output() onClosePermisos = new EventEmitter<boolean>();

  subscription: Subscription;

  listausuarios: any = [];
  public filterQuery = "";

  titulo_permiso: string;
  tipo: string;
  id_permiso: number;

  iconocerrar: string = 'fa fa-times';
  iconoexpandir: string = 'fa fa-expand';


  constructor(private seguridad: SeguridadService,
              private router:Router,
              private normasService: NormasService,
              private usuariosService: UsuariosService,
              private globalEventsManager: GlobalEventsManager,
              private activatedRoute: ActivatedRoute){

  }

  ngOnInit(){

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });



  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){
    if (changes['_titulo_permiso']){
      this.titulo_permiso = changes['_titulo_permiso'].currentValue;
    }
    if (changes['_id_permiso']){
      this.id_permiso = changes['_id_permiso'].currentValue;
    }
    if (changes['_tipo']){
      this.tipo = changes['_tipo'].currentValue;
    }

    this.getListaPermisosAncep(this.tipo, this.id_permiso);
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  cerrar(){
    this.onClosePermisos.emit(true);
  }

  stripText(val: string){
    var cadena: string = "";

    if (val != null){
      if (val.length>25){
        cadena = val.substr(0, 25)+"...";
      }else{
        cadena = val;
      }
    }

    return cadena;
  }

  getListaPermisosAncep(tipo: string, id: number){
    this.usuariosService.getListaPermisosAncep(tipo, id).subscribe(
      data => {
        if (data){



          this.listausuarios = data.json().lista;

          console.log(this.listausuarios);

          setTimeout(() => this.inicializarListaPermisos(), 500);


        }
      }
    );
  }

  inicializarListaPermisos(){

    for (let i = 0; i < this.listausuarios.length; i++) {
      if (this.listausuarios[i].permiso == 1){
        jQuery('#check_'+this.listausuarios[i].id_user).prop("checked", true);
      }
    }
  }

  modificarPermiso(usuario: any, id_usuario: number){
    if (jQuery('#check_'+id_usuario).is(':checked')){
      usuario.permiso = 1;
    }else{
      usuario.permiso = 0;
    }

    if (this.tipo == 'bloque'){
      usuario.id_bloque = this.id_permiso;
      usuario.action = "prodancepSetUsuarioBloque";
    }

    if (this.tipo == 'area'){
      usuario.id_area = this.id_permiso;
      usuario.action = "prodancepSetUsuarioArea";
    }

    if (this.tipo == 'modulo'){
      usuario.id_modulo = this.id_permiso;
      usuario.action = "prodancepSetUsuarioModulo";
    }

    if (this.tipo == 'norma'){
      usuario.id_norma = this.id_permiso;
      usuario.action = "prodancepSetUsuarioNorma";
    }

    if (this.tipo == 'evidencia'){
      usuario.id_evidencia = this.id_permiso;
      usuario.action = "prodancepSetUsuarioEvidencia";
    }

    this.usuariosService.setListaPermisosAncep(usuario).subscribe(
      data => {
        if (data){

          let al: any = {
            "texto" : "Permiso guardado",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);

          //this.listaaplicaciones = data.json().accesos;

        }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/inventarionormaspenal/formulariopermisospenal.component.ts